import {combineReducers}         from "redux"
import Event                     from "./Event"

const AdBuilder = combineReducers({
  Event,
})

export default AdBuilder
